import { generateDocumentSources } from "@/components/guest-chat/metadataUtils";
import { Colors } from "@/enums/Colors";
import { Metadata } from "@/models/ai-chat/LazoChatMessage";
import { MetadataType } from "@/types/MetadataType";
import { Box } from "@mui/material";
import { marked } from "marked";
import { useSearchParams } from "react-router-dom";

interface Props {
  message: string;
  isBotMessage: boolean;
  isBotTheMessageReceiver: boolean;
  metadata?: Metadata;
}

export const LazoChatMessageComponent = ({ message, isBotMessage, isBotTheMessageReceiver, metadata }: Props) => {
  marked.use({
    extensions: [
      {
        name: "link",
        renderer(token) {
          return `<a href="${token.href}" target="_blank" style="background-color:${Colors.LAZO_PURPLE};color:${Colors.WHITE};padding:0 0.15rem;text-decoration:none;">${token.text}</a>`;
        },
      },
    ],
  });

  const [_, setSearchParams] = useSearchParams();

  // Generate metadata elements
  let metadataElements = <></>;
  if (metadata) {
    let metadataObj = metadata as any;
    if (typeof metadata !== "object") {
      metadataObj = JSON.parse(metadata as any);
    }
    switch (metadataObj.metadataType) {
      case MetadataType.DOCUMENT_QA:
        metadataElements = generateDocumentSources(metadataObj.documents, setSearchParams);
        break;
      default:
        break;
    }
  }

  return (
    <Box>
      <Box dangerouslySetInnerHTML={{ __html: marked.parse(message) }} />
      {metadataElements}
    </Box>
  );
};
